import { ChangeDetectionStrategy, Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EmployeeModel } from '@libs/account/models';
import { SubmitGroupComponent } from '@libs/form/components';
import { SubmitGroupItemModel } from '@libs/form/models';
import { EmployeeDeleteSubmitGroupItem } from './employee-delete.model';

@Component({
  selector: 'ui-employee-delete',
  templateUrl: './employee-delete.component.html',
  styleUrls: ['./employee-delete.component.scss'],
  imports: [
    FormsModule,
    SubmitGroupComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmployeeDeleteComponent {
  public readonly employee: InputSignal<EmployeeModel | undefined> = input<EmployeeModel | undefined>();
  public readonly submitResult: OutputEmitterRef<string> = output<string>();
  public itemSubmit: SubmitGroupItemModel = EmployeeDeleteSubmitGroupItem;

  public onSubmit(): void {
    const employeeId: string | undefined = this.employee()?.id;

    if (employeeId) {
      this.submitResult.emit(employeeId);
    }
  }
}

